import * as React from 'react';
import { IconLogoSquareGoparrot } from '@goparrot-dashboard/shared-ui';
import classNames from 'classnames';
import styles from './AuthLayout.module.scss';

const currentYear = new Date().getFullYear();

export const AuthLayout: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <div className="tw-flex tw-min-h-screen tw-bg-white">
      <div className={classNames(styles.image, 'tw-hidden lg:tw-block tw-relative tw-w-0 tw-flex-1')}></div>
      <div className="tw-flex-1 tw-flex tw-flex-col tw-justify-between tw-pt-4 tw-px-5 tw-pb-5 sm:tw-px-6 lg:tw-flex-none">
        <header className="tw-flex tw-flex-col">
          <figure className="tw--mb-2">
            <IconLogoSquareGoparrot className="tw-h-8 tw-w-auto" />
          </figure>
        </header>
        <main className="tw-mx-auto tw-w-full tw-max-w-sm lg:tw-w-96">{children}</main>
        <footer className="tw-mt-4">
          <p>&copy; Square, {currentYear}</p>
        </footer>
      </div>
    </div>
  );
};
